/**
 * 金額の処理
 * 100000000 => 10000万円
 *
 * @param {int} amount
 * @return {int}
 */
export function moneyFormatter(amount) {
    const formatAmount = amount / 10000

    return Math.floor(formatAmount)
}


/**
 * 数値のカンマ区切り(3桁)
 * @param {*} number
 */
export function numberFormat(number) {
    if (number === undefined) {
        return ''
    }

    return String(number).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') + '円';
}